<template>
  <b-card no-body class="card-image-content card-type-content mt-1 overflow-hidden">
    <deal-header-chat
      v-if="chat_deal"
      :title="chat_deal.title"
      :price="chat_deal.price"
    />
    <div class="p-1">
    <!-- HEADER -->
    <div class="d-flex align-items-center mb-1">
      <div class="position-relative mr-1">
        <b-avatar
          size="3.5rem"
          variant="light-secondary"
          :src="verifyAsset(avatar_src)"
        />
      </div>

      <div class="d-flex flex-column">
        <span class="font-weight-bold">
          {{ message.sender.first_name }} {{ message.sender.last_name }}
          <image-verified />
        </span>
        <small class="text-muted"> {{ $t("campaigns.post") }} · {{ $t('creator.textNow')}} </small>
      </div>
    </div>

    <!-- LINK PREVIEW -->
    <div class="box-link-content p-1">
      <div class="d-flex align-items-center">
        <feather-icon icon="LinkIcon" size="18" class="mr-1 text-primary" />

        <a
          :href="message.message"
          target="_blank"
          class="text-truncate link-content"
        >
          {{ message.message }}
        </a>
      </div>
    </div>

    <div class="mt-1 actions-buttons" v-if="local_show_btns && !show_modal_change && message.chat_deals.status !== 'finished'">
      <b-button
        @click="openRevisionModal"
        variant="outline-dark"
        class="w-100"
        >{{ $t("creator.requestRevision") }}</b-button
      >
      <b-button
        @click="openAcceptModal"
        variant="blue-button"
        class="blue-button w-100"
        >{{ $t("creator.acceptLinkDeal") }}</b-button
      >
    </div>

    <div v-if="show_modal_change" class="w-100 border-top mt-1 pt-1">
      <div v-if="!modal_accept">
        <div class="w-100">
          <h5>{{ $t("creator.requestRevision") }}</h5>
          <b-form-textarea
            class="mt-1"
            v-model="revision_text"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <div class="mt-1 actions-buttons">
            <b-button
              @click="hiddenModalChange()"
              variant="light"
              :disabled="is_loading"
              >{{ $t("creator.cancel") }}</b-button
            >
            <b-button
              variant="blue-button"
              :disabled="!revision_text || is_loading"
              @click="submitRequestRevision()"
              class="blue-button"
              >
              <b-spinner v-if="is_loading" style="width:14px;height:14px;" class="mr-50" />
              {{ $t("creator.submit") }}</b-button
            >
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <h5>{{ $t("creator.collaborationAccepted") }}</h5>
          <span class="text-muted">{{ $t("creator.byAcceptDealLinks") }}</span>
          <div class="mt-1">
            <b-form-checkbox v-model="accept_links">
              {{ $t("creator.linksAccept") }}            
            </b-form-checkbox>
          </div>

          <div class="mt-1 actions-buttons">
            <b-button
              @click="hiddenModalChange()"
              variant="light"
              :disabled="is_loading"
              >{{ $t("creator.cancel") }}</b-button
            >
            <b-button
              @click="submitAcceptLinks()"
              class="blue-button"
              variant="blue-button"
              :disabled="is_loading"
              >
              <b-spinner v-if="is_loading" style="width:14px;height:14px;" class="mr-50" />
              {{ $t("creator.submit") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
    </div>
  </b-card>
</template>
  
    
<script>
import {
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BFormTextarea,
  BFormCheckbox,
} from "bootstrap-vue";
import { getIconWhite, getIconColor } from "@/libs/utils/icons";
import { verifyAsset } from "@/libs/utils/urls";
import { showToast } from '@/libs/utils/others';
import { submitRequestRevisionLinksUseCase, submitAcceptLinksUseCase } from '@/application/proposals/chats.usecase';

export default {
  name: "view-links-chats",
  components: {
    BCard,
    BAvatar,
    BButton,
    BSpinner,
    BFormTextarea,
    BFormCheckbox,
    ImageVerified: () => import("@/views/components/image/ImageVerified.vue"),
    DealHeaderChat: () => import("@/views/pages/proposals/chat/dealHeaderChat.vue"),
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    show_btns: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getIconWhite,
      getIconColor,
      verifyAsset,
      show_modal_change: false,
      change_modal: 0,
      revision_text: "",
      accept_links: false,
      modal_accept: false,
      local_show_btns: this.show_btns,
      is_loading: false,
    };
  },
  computed: {
    avatar_src() {
      return this.message?.sender?.avatar || ""
    },
    chat_deal() {
      return this.message?.chat_deals?.deal || null;
    },
    uuid_chat_deal() {
      return this.message?.chat_deals?.uuid || null;
    },
  },
  methods: {
    hiddenModalChange() {
      this.show_modal_change = false;
      this.change_modal = this.change_modal + 1;
      this.revision_text = "";
      this.accept_links = false;
      this.modal_accept = false;
    },
    openRevisionModal() {
      this.openModalChange(false);
    },

    openAcceptModal() {
      this.openModalChange(true);
    },

    openModalChange(is_accept) {
      this.show_modal_change = true;
      this.change_modal++;
      this.modal_accept = is_accept;
    },
    async submitAcceptLinks() {
      this.is_loading = true;
      try {
        await submitAcceptLinksUseCase({
          uuid_chat_deal: this.uuid_chat_deal,
          accept_links: this.accept_links
        });

        this.$emit("approved");
        this.local_show_btns = false;
        this.modal_accept = false;
        this.show_modal_change = false;
        showToast(this, 'success', 'CheckCircleIcon', 'creator.acceptedLinksTitle', 'creator.acceptedLinksText');

      } catch (error) {
        if (error.message === "NEED_CONFIRM") {
          showToast(this, 'danger', 'AlertCircleIcon', 'creator.needConfirmLink');
        } else {
          showToast(this, 'danger', 'AlertTriangleIcon', 'creator.errorLink');
        }
      } finally {
        this.is_loading = false;
      }
    },

    async submitRequestRevision() {
      this.is_loading = true;
      try {
        const response = await submitRequestRevisionLinksUseCase({
          uuid_chat_deal: this.uuid_chat_deal,
          revision_text: this.revision_text
        });

        this.$emit("request_sent", response);
        this.local_show_btns = false;
        this.hiddenModalChange();
        showToast(this, 'success', 'CheckCircleIcon', 'creator.requestSentTitle', 'creator.requestSentText');

      } catch (error) {
        if (error.message === "NEED_TEXT") {
          showToast(this, 'danger', 'AlertCircleIcon', 'creator.needRevisionText');
        } else {
          showToast(this, 'danger', 'AlertTriangleIcon', 'creator.errorSendChange');
        }
      } finally {
        this.is_loading = false;
      }
    },
  },
};
</script>
    
  <style scoped>
.metric-row {
  display: flex;
  align-items: center;
  width: 100%;
}
.metric-line {
  flex-grow: 1;
  border-bottom: 1px dashed #ccc;
  margin: 0 8px;
}
.container-interactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.card-content-all {
  width: 100%;
}
.icon-network {
  position: relative;
  top: 30px;
  z-index: 9;
  background: white;
  border-radius: 50%;
  bottom: 0;
  right: 0;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  border-radius: 1%;
  box-shadow: none;
}
.card-type-content {
  display: flex;
  height: 90%;
  border: 1px solid #ccccccb0;
  border-radius: 1em;
}
.text-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-right {
  border-left: 7px solid #55a6c4;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 10px;
}
.box-link-content {
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.link-content {
  font-weight: 500;
  color: #3b82f6;
  text-decoration: none;
}

.link-content:hover {
  text-decoration: underline;
}
.actions-buttons {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
}
@media (max-width: 576px) {
  .actions-buttons {
    flex-direction: column-reverse;
  }
  .actions-buttons .btn {
    width: 100%;
  }
}
</style>